<template>
  <!-- Dashboard Box -->
  <div class="col-xl-12">
    <div id="test1" class="dashboard-box">
      <!-- Headline -->
      <div class="headline">
        <h3>
          <i class="icon-material-outline-lock"></i>
          Update User Security Data
        </h3>
      </div>

      <div class="content with-padding padding-bottom-10">
        <div class="row">
          <div class="col-xl-6">
            <div class="submit-field">
              <h5>Secret Answer</h5>
              <input type="text" class="with-border" />
            </div>
          </div>

          <div class="col-xl-6">
            <div class="submit-field">
              <h5>Upload a valid means of Identification</h5>
              <div class="uploadButton ">
                <input
                  class="uploadButton-input"
                  type="file"
                  accept="image/*"
                  id="upload"
                  multiple
                />
                <label class="uploadButton-button ripple-effect" for="upload"
                  >Upload a valid Identification dcument</label
                >
                <span class="uploadButton-file-name"
                  >Driver's Licence or International Passport or Voter's
                  Card</span
                >
              </div>
            </div>
          </div>

          <div class="col-xl-12">
            <a
              href="#"
              class="button ripple-effect  big "
              @click="setSecurityQuestionAndAnswer()"
              ><i class="icon-material-outline-lock mr-1"></i>
              Update User Data
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { UPDATE_USER_SECURITY_DATA } from "../../../core/config/endpoints/user";
import { postCall } from "../../../core/services/http.service";

export default {
  name: "UpdateUserSecurityData",
  data() {
    return {};
  },
  methods: {
    updateUserSecurityData(request) {
      postCall(UPDATE_USER_SECURITY_DATA, {
        identification: request.identification,
        security_answer: request.securityAnswer,
      })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },
  },
};
</script>

<style></style>
